<!-- ══════════════════════════════════════════════════════════════════════════
     CIERRE DE CAJA — consola de CrediTotal.

     🔴 Pedido de Juan, 2026-09-20: *«los administradores también pueden bajarse un
     cierre de caja donde le traiga todos los créditos, cuándo fue la inicial y
     cuánto fue, y cuánto se financió»*.

     Lo que decide quien abre esta pantalla: SI LA PLATA DEL DÍA CUADRA — cuántos
     créditos se cobraron, cuánto entró de inicial y cuánto quedó financiado. Por
     eso la tabla empieza arriba: dos controles en el encabezado, una cinta que
     dice cómo se lee el número, y las filas.

     El molde es `organizacion.component.html` y el contrato del rediseño del
     2026-09-20: secciones planas, nada de tarjeta para envolver lectura, una sola
     cinta, nada por encima de `text-2xl`, y los filtros en la URL.
     ══════════════════════════════════════════════════════════════════════════ -->
<!-- 🔴 SIN MIGA, SIN TÍTULO Y SIN ENVOLTORIO DE PÁGINA — 2026-09-21.
     Esta pantalla pasó a ser una RUTA HIJA de la ficha del comercio, por
     decisión de Juan: *«¿por qué ese cierre de caja está ahí? Ese cierre de caja
     no debería estar»* suelto en el menú de CrediTotal.

     El motivo medido: sin comercio elegido la pantalla no hacía nada — mostraba
     «elige un comercio arriba» y se quedaba ahí. Una entrada de menú de primer
     nivel que queda inerte hasta que elijas otra cosa está en el nivel
     equivocado. Dentro de la ficha, el comercio ya está elegido.

     El padre pone la miga, el nombre del comercio, su estado, la tira del portal
     y la barra de pestañas. Acá quedan el DÍA y el ARCHIVO, que son de esta
     pantalla y de ninguna otra. -->
<div class="space-y-8">

    <!-- ══ El día y el archivo ══════════════════════════════════════════════ -->
    <div class="flex flex-wrap items-end justify-end gap-3 pt-2">
      <div class="flex flex-wrap items-end gap-3">
        <div>
          <label class="kb-label" for="fFecha">Día</label>
          <input id="fFecha" type="date" class="kb-input w-[9.5rem] tabular-nums"
                 [(ngModel)]="filtros.fecha" (ngModelChange)="onFiltroInmediato()">
        </div>

        <!-- 🔴 El botón dice su objeto, no «Descargar». Y dice CUÁL objeto: con un
             filtro puesto baja lo filtrado, no el día — prometer «el día» y
             entregar una caja sola es la manera de que alguien cuadre mal y no
             tenga cómo darse cuenta.
             Se apaga cuando no hay nada que bajar: un archivo con el encabezado
             solo y ninguna fila se abre, no falla, y hace perder diez minutos
             averiguando por qué está vacío. -->
        <button type="button" class="kb-btn kb-btn-primary"
                [disabled]="cargando || bajando || !creditos.length"
                [title]="!creditos.length ? 'No hay créditos que bajar en este día' : ''"
                (click)="bajar()">
          <i class="fas" [ngClass]="bajando ? 'fa-spinner fa-spin' : 'fa-file-download'" aria-hidden="true"></i>
          {{ bajando ? 'Preparando el archivo…'
                     : (esElDiaCompleto ? 'Bajar el cierre del día' : 'Bajar el cierre filtrado') }}
        </button>
      </div>
    </div>

    <!-- ══ El archivo no bajó ═══════════════════════════════════════════════
         Aviso con borde (`.kb-aviso`), no una segunda cinta: la cinta es UNA por
         pantalla y es la de abajo. Y va aparte del error de lectura a propósito —
         que el archivo falle no tiene por qué borrar la tabla que ya está bien. -->
    <div class="kb-aviso kb-aviso-peligro" *ngIf="errorAlBajar">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p class="kb-aviso-titulo">No se pudo bajar el cierre</p>
        <p>{{ errorAlBajar }}</p>
      </div>
    </div>

    <!-- ══ Cargando ═════════════════════════════════════════════════════════ -->
    <!-- El esqueleto conserva la forma de lo que viene: la cinta y la tabla. -->
    <div *ngIf="cargando" class="space-y-6" aria-live="polite" aria-busy="true">
      <div class="kb-skeleton h-14 w-full rounded-lg"></div>
      <div class="kb-skeleton h-5 w-40"></div>
      <div class="kb-skeleton h-64 w-full rounded-lg"></div>
    </div>

    <!-- ══ No se pudo leer ══════════════════════════════════════════════════
         El tercero de los tres vacíos, y el que más confunde si se lo confunde
         con «no hubo nada»: aquí NO se sabe qué pasó ese día. -->
    <!-- ══ CUARTO ESTADO: FALTA ELEGIR EL COMERCIO ═════════════════════════════
         🔴 No es un error y no se pinta de rojo. Un cierre de caja es de UNA
         caja de UN comercio: con «Todos los comercios» puesto arriba no hay
         nada que cerrar, y el servidor contesta que le falta el comercio.
         Eso es una INSTRUCCIÓN, no una falla — decirlo en rojo manda al
         operador a buscar un problema que no existe.
         Medido en pantalla el 2026-09-20: se veía «No se pudo leer el cierre ·
         Faltan datos obligatorios de la operación», que no apunta a la causa
         ni de casualidad. -->
    <div class="kb-empty" *ngIf="!cargando && faltaElComercio">
      <span class="kb-empty-icono"><i class="fas fa-store" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">Elige un comercio arriba</p>
      <p class="kb-empty-texto">
        El cierre es de la caja de un comercio, así que hay que decir de cuál.
        Cambia «Todos los comercios» por uno en el selector de la barra de arriba.
      </p>
    </div>

    <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && error && !faltaElComercio">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p class="kb-aviso-titulo">No se pudo leer el cierre</p>
        <p>{{ error }}</p>

        <!-- 🔴 SE FUE UN RENGLÓN QUE YA NO ERA CIERTO, 2026-09-21.
             Decía que faltaba el gemelo `/admin/caja/cierre-detallado` y mandaba
             a mirar el cierre desde el portal del comercio. Ese endpoint SE
             CONSTRUYÓ el mismo día, y esta pantalla ya lo usa. Un texto de
             pantalla que describe un pendiente resuelto manda a alguien a
             perseguir algo que existe — y lo dice con la autoridad de estar
             escrito en el producto. -->

        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3"
                *ngIf="errorReintentable" (click)="cargar()">
          <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar el cierre
        </button>
      </div>
    </div>

    <!-- ══ LA CINTA — cómo se lee este número. Una por pantalla ══════════════
         Dos cosas que sin decirlas hacen que alguien cuadre mal:
           · el ALCANCE, tal cual lo manda el servidor (sólo lo confirmado); y
           · que este cierre cuenta por DÍA y por CAJERO, no por turno. -->
    <div class="kb-cinta kb-cinta-info" *ngIf="!cargando && !error && alcance">
      <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
      <div class="space-y-1">
        <p class="m-0"><strong class="font-semibold">{{ alcance }}</strong></p>
        <!-- Medido el 2026-09-19: de 9 ventas confirmadas de una misma cédula, 6 no
             colgaban de ningún turno de caja — las crea la integración del comercio
             sin pasar por una caja abierta. -->
        <p class="m-0">
          Cuenta por día y por cajero, no por turno: hay ventas que la integración del comercio
          crea sin pasar por una caja abierta, así que este cierre puede dar más que el cuadre de
          los turnos. No es un error.
        </p>
      </div>
    </div>

    <!-- ══ LOS CRÉDITOS ═════════════════════════════════════════════════════ -->
    <section class="kb-tarjeta" *ngIf="!cargando && !error">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Créditos cobrados</h2>
        <span class="kb-tarjeta-accion shrink-0 text-sm tabular-nums text-muted-foreground" *ngIf="dia">{{ dia }}</span>
      </div>
      <div class="kb-tarjeta-cuerpo">

      <!-- Dos controles a la vista, y los otros dos detrás de un interruptor:
           el día ya está arriba, aquí va el cajero, que es por quien se pregunta
           cuando algo no cuadra. Tienda y caja no se usan todos los días. -->
      <div class="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
        <div class="min-w-0 flex-1">
          <label class="kb-label" for="fCedula">Cédula del cajero</label>
          <div class="kb-buscador max-w-xs">
            <i class="fas fa-id-card kb-buscador-icono" aria-hidden="true"></i>
            <input id="fCedula" type="text" class="kb-input kb-input-icono tabular-nums" autocomplete="off"
                   placeholder="V-12345678"
                   [(ngModel)]="cedulaTexto" (ngModelChange)="onCedulaCambio()" (keyup.enter)="onCedulaEnter()">
          </div>
          <!-- 🔴 Lo que es: texto que el cajero teclea al cobrar, no una atribución
               probada (`cashier_declared`). La pantalla no lo presenta como si
               respondiera por nadie. -->
          <p class="kb-hint">Es la cédula que el cajero declara al cobrar.</p>
        </div>

        <div class="flex shrink-0 items-center gap-2">
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm"
                  [attr.aria-expanded]="masFiltros" (click)="masFiltros = !masFiltros">
            <i class="fas" [ngClass]="masFiltros ? 'fa-chevron-up' : 'fa-sliders-h'" aria-hidden="true"></i>
            {{ masFiltros ? 'Ocultar tienda y caja' : 'Filtrar por tienda o caja' }}
          </button>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="hayFiltros" (click)="quitarFiltros()">
            <i class="fas fa-times" aria-hidden="true"></i>Quitar los filtros
          </button>
        </div>
      </div>

      <div class="flex flex-wrap items-end gap-3" *ngIf="masFiltros">
        <div>
          <label class="kb-label" for="fTienda">Tienda</label>
          <input id="fTienda" type="text" class="kb-input w-40" placeholder="Código de la tienda"
                 [(ngModel)]="filtros.tienda" (change)="onFiltroInmediato()">
        </div>
        <div>
          <label class="kb-label" for="fCaja">Caja</label>
          <input id="fCaja" type="text" class="kb-input w-32 tabular-nums" placeholder="Número"
                 [(ngModel)]="filtros.caja" (change)="onFiltroInmediato()">
        </div>
      </div>

      <!-- ── La tabla, plana y sin tarjeta alrededor ──────────────────────── -->
      <div class="kb-tabla-plana">
        <table class="kb-table">
          <thead class="kb-thead">
            <tr>
              <th class="kb-th">Crédito</th>
              <th class="kb-th">Cliente</th>
              <th class="kb-th">Punto de venta</th>
              <th class="kb-th">Plan</th>
              <th class="kb-th kb-th-num">Inicial cobrada</th>
              <th class="kb-th kb-th-num">Financiado</th>
            </tr>
          </thead>

          <tbody>
            <!-- Los dos vacíos que NO son el mismo hecho: un día sin ventas contra
                 un filtro que no encontró nada. Confundirlos hace que alguien
                 declare cerrado un día que sí tuvo créditos. -->
            <tr *ngIf="!creditos.length">
              <td colspan="6">
                <div class="kb-empty">
                  <span class="kb-empty-icono">
                    <i class="fas" [ngClass]="hayFiltros ? 'fa-filter' : 'fa-inbox'" aria-hidden="true"></i>
                  </span>
                  <p class="kb-empty-titulo">
                    {{ hayFiltros ? 'Ningún crédito coincide con este filtro' : 'No se cobró ningún crédito este día' }}
                  </p>
                  <p class="kb-empty-texto">
                    {{ hayFiltros
                       ? 'Prueba con otro día, o quita la tienda, la caja o la cédula del cajero.'
                       : 'El día está leído y no hubo cobros confirmados. Si esperabas alguno, revísalo en Solicitudes de crédito: las que quedaron a medias no entran en el cierre.' }}
                  </p>
                  <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="hayFiltros"
                          (click)="quitarFiltros()">Quitar los filtros</button>
                </div>
              </td>
            </tr>

            <tr class="kb-tr last:border-b-0" *ngFor="let c of creditos">
              <td class="kb-td">
                <span class="kb-td-titulo kb-td-mono">{{ c.solicitud || '—' }}</span>
                <p class="kb-td-sub" *ngIf="c.credito || c.factura">
                  <span *ngIf="c.credito">{{ c.credito }}</span>
                  <span *ngIf="c.credito && c.factura"> · </span>
                  <span *ngIf="c.factura">factura {{ c.factura }}</span>
                </p>
              </td>

              <td class="kb-td kb-td-mono tabular-nums">{{ c.cliente || '—' }}</td>

              <td class="kb-td">
                <span *ngIf="puntoDeVenta(c)">{{ puntoDeVenta(c) }}</span>
                <span class="italic text-muted-foreground" *ngIf="!puntoDeVenta(c)">—</span>
                <p class="kb-td-sub tabular-nums" *ngIf="c.cajero">cajero {{ c.cajero }}</p>
              </td>

              <td class="kb-td">
                <span *ngIf="c.plan">{{ c.plan }}</span>
                <span class="italic text-muted-foreground" *ngIf="!c.plan">—</span>
                <!-- El cero se muestra: `cuotas` en 0 es un plan sin cuotas, no un
                     dato que falta, y filtrar por `>0` borra esa diferencia. -->
                <p class="kb-td-sub tabular-nums" *ngIf="c.cuotas !== null && c.cuotas !== undefined">
                  {{ c.cuotas }} {{ c.cuotas === 1 ? 'cuota' : 'cuotas' }}
                </p>
              </td>

              <td class="kb-td kb-td-num">
                <span class="font-medium">{{ formatoMonto(c.inicial_usd) }}</span>
                <!-- Cuándo fue la inicial: es el momento en que el cobro quedó
                     asentado (`confirmed_at`), no cuándo nació el borrador ni
                     cuándo firmó el cliente — los tres pueden caer en días
                     distintos y sólo uno es cuándo entró la plata. -->
                <p class="kb-td-sub tabular-nums" *ngIf="c.inicial_cuando">
                  {{ c.inicial_cuando | date:'HH:mm' }}
                </p>
              </td>

              <td class="kb-td kb-td-num">{{ formatoMonto(c.financiado_usd) }}</td>
            </tr>
          </tbody>

          <!-- ── El total, al pie ─────────────────────────────────────────────
               Cuántos créditos, cuánto de inicial y cuánto financiado. En dólares
               y con su símbolo, porque el endpoint devuelve dólares siempre y así
               lo dice el alcance de arriba. -->
          <tfoot *ngIf="creditos.length">
            <tr class="border-t-2 border-border bg-muted/40">
              <td class="kb-td font-semibold" colspan="4">
                {{ esElDiaCompleto ? 'Total del día' : 'Total de lo filtrado' }}
                <span class="ml-2 font-normal tabular-nums text-muted-foreground">
                  {{ total.creditos }} {{ total.creditos === 1 ? 'crédito' : 'créditos' }}
                </span>
              </td>
              <td class="kb-td kb-td-num font-semibold">{{ formatoMonto(total.inicial_usd) }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ formatoMonto(total.financiado_usd) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      </div>
    </section>
  </div>
